import React, { forwardRef } from 'react';
import { CnBox, CnCard as UICnCard } from '@cainiaofe/cn-ui-m';
import { calculateTextExprValue, isArrayNotEmpty, isDesignMode, makeButtons, mergeHandleProps, } from '@/common/util/util';
import { ButtonPosition } from '@/type/button-position';
import isPlainObject from 'lodash/isPlainObject';
import classnames from 'classnames';
const getExtraDom = (slot) => {
    if (isArrayNotEmpty(slot)) {
        return slot.map((item, index) => {
            return React.cloneElement(item);
        });
    }
    if (slot) {
        return slot;
    }
    return null;
};
const CnCard = forwardRef((props, ref) => {
    if (!UICnCard) {
        return null;
    }
    const { _context, buttons, action, title, subTitle, slotManager, handleProps, children, ...rest } = props;
    const isDesign = isDesignMode(props);
    const state = _context?.state;
    const { headerBottomSlot, headerRightSlot } = slotManager || {};
    const realTitle = calculateTextExprValue(title, {
        recordDataSource: {},
        state,
    });
    const realSubTitle = calculateTextExprValue(subTitle, {
        recordDataSource: {},
        state,
    });
    let componentProps = {
        title: realTitle,
        subTitle: realSubTitle,
        ...rest,
    };
    const temp = mergeHandleProps({
        handleProps,
        componentProps,
        _context,
    });
    if (isPlainObject(temp)) {
        componentProps = temp;
    }
    const Action = React.isValidElement(action)
        ? action
        : makeButtons({
            buttons: action?.map((item) => {
                let realChildren = item?.children;
                return {
                    ...item,
                    // size:'small',
                    type: item.type ? item.type : 'primary',
                    text: true,
                    position: ButtonPosition.normalCardAction,
                    children: realChildren,
                };
            }),
            _context,
            state,
            recordDataSource: {},
        });
    if (isArrayNotEmpty(Action) ||
        React.isValidElement(Action) ||
        headerRightSlot) {
        componentProps.action = (React.createElement(React.Fragment, null,
            headerRightSlot ? (React.createElement(CnBox, { className: classnames({
                    'lc-cn-card-right-filter-slot': _context?.cnUtils?.isPC,
                }) }, getExtraDom(headerRightSlot))) : null,
            isArrayNotEmpty(Action) || React.isValidElement(Action) ? (React.createElement(CnBox, { spacing: 8, direction: 'row' }, Action)) : null));
    }
    const subAction = makeButtons({
        buttons: buttons?.map((item) => {
            let realChildren = item?.children;
            return {
                ...item,
                // size:'small',
                type: item.type ? item.type : 'primary',
                text: true,
                position: ButtonPosition.normalCardSubAction,
                children: realChildren,
            };
        }),
        _context,
        state,
        recordDataSource: {},
    });
    if (isArrayNotEmpty(subAction)) {
        componentProps.subAction = (React.createElement(CnBox, { spacing: 8, direction: 'row' }, subAction));
    }
    return (React.createElement(UICnCard, { ...componentProps },
        getExtraDom(headerBottomSlot),
        children));
});
CnCard.displayName = 'CnCard';
export default CnCard;
